import { Component, OnInit, ChangeDetectionStrategy, Inject, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { RegistroActividadSitioProcesamientoFormComponent } from '../registro-actividad-sitio-procesamiento-form.component';
import { SitioProcesamiento } from '../../entity-sitios-procesamiento/sitios-procesamiento.model';
import { Store, select } from '@ngrx/store';
import { State } from '../../../vista-usuario/vista-usuario.state';
import { NotificationService } from 'projects/registro-personas-empresas/src/app/core/core.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { selectAllSitiosProcesamientoFromCurrentEmpresa } from '../../entity-sitios-procesamiento/sitios-procesamiento.selectors';
import { entitySitiosProcesamientoAddRequest } from '../../entity-sitios-procesamiento/sitios-procesamiento.actions';

@Component({
  selector: 'rpe-registro-actividad-sitio-procesamiento-form-container',
  templateUrl: './registro-actividad-sitio-procesamiento-form-container.component.html',
  styleUrls: ['./registro-actividad-sitio-procesamiento-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistroActividadSitioProcesamientoFormContainerComponent implements OnInit {
  @ViewChild(RegistroActividadSitioProcesamientoFormComponent)
  formComponent: RegistroActividadSitioProcesamientoFormComponent;

  laboratorioId: string = ''

  subscriptions: Subscription[] = []

  sitioProcesamiento: SitioProcesamiento = null
  sitioProcesamientoCurrentEmpresa: SitioProcesamiento[] = []

  formInvalid: boolean = false

  newSitio: SitioProcesamiento = null

  constructor(
    private store: Store<State>,
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<RegistroActividadSitioProcesamientoFormContainerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      sitioProcesamiento?: SitioProcesamiento
    },
  ) { }

  ngOnInit(): void {
    this.store.pipe(
      select(selectAllSitiosProcesamientoFromCurrentEmpresa)
    ).subscribe((sitiosProcesamiento) => {
      this.sitioProcesamientoCurrentEmpresa = sitiosProcesamiento
    })

    if (this.data.sitioProcesamiento) {
      this.sitioProcesamiento = this.data.sitioProcesamiento
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach((s) => s.unsubscribe())
    }
  }

  formStatusChange(status: string): void {
    if (status === 'INVALID') {
      this.formInvalid = true
    }

    if (status === 'VALID') {
      this.formInvalid = false
    }
  }

  formValueChange($event: SitioProcesamiento): void {
    if ($event.id) {
      const editedLab = this.sitioProcesamientoCurrentEmpresa.find((lab) => lab.id === $event.id)

      this.sitioProcesamientoCurrentEmpresa = this.sitioProcesamientoCurrentEmpresa.filter((lab) => lab.id != editedLab.id)

      this.sitioProcesamientoCurrentEmpresa = [...this.sitioProcesamientoCurrentEmpresa, $event]
    }

    if (!$event.id) {
      this.newSitio = $event
    }
  }

  onAdd(): void {
    if (this.formInvalid) {
      this.notificationService.info('Complete los campos requeridos')
      this.formComponent?.checkErrors()
      return
    }

    this.store.dispatch(
      entitySitiosProcesamientoAddRequest({
        item: this.newSitio ? [...this.sitioProcesamientoCurrentEmpresa, this.newSitio] : this.sitioProcesamientoCurrentEmpresa
      })
    )

    this.dialogRef.close()
  }

  onCancel(): void {
    this.dialogRef.close()
  }
}
